import React from 'react';
import styled from 'styled-components';

interface Props {
  value?: string;
  checkedValue?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const Radio = ({ value, checkedValue, children, onClick }: Props) => {
  return (
    <Container onClick={onClick}>
      <IcContainer className={checkedValue === value ? 'active' : ''}>
        {checkedValue === value ? <IcChecked /> : <DefaultRadio />}
      </IcContainer>
      {children}
    </Container>
  );
};

export default Radio;
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const IcContainer = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 4px;
  &.active {
    background: #008bff;
  }
`;

const DefaultRadio = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' fill='#F6F7FC' stroke='#86909C' />
  </svg>
);

const IcChecked = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      d='M8.10593 15C7.83913 15 7.58567 14.8884 7.39891 14.6931L3.62364 10.7447C3.23678 10.3401 3.23678 9.67039 3.62364 9.26578C4.0105 8.86118 4.65082 8.86118 5.03767 9.26578L8.10593 12.4747L14.9627 5.30345C15.3495 4.89885 15.9898 4.89885 16.3767 5.30345C16.7635 5.70806 16.7635 6.37775 16.3767 6.78235L8.81294 14.6931C8.62618 14.8884 8.37272 15 8.10593 15Z'
      fill='white'
    />
  </svg>
);
